import { connect } from 'react-redux'
import get from 'lodash/get'

import { Loader } from './Loader'

const mapStateToProps = state => ({
  searchRequest: get(state, 'pclnBootstrapData.searchRequest', {}),
  ctaTitle: get(state, 'listingsLoadingMessage', ''),
})

const LoaderContainer = connect(mapStateToProps, {})(Loader)

export { LoaderContainer }
